import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type CrossfadeTextProps = {
  children: ReactNode;
  className?: string;
  textKey: string;
};

// Opacity only: the span stays inline, where a transform would not apply anyway. A new
// textKey remounts the span, which replays the entrance animation.
export const CrossfadeText: FC<CrossfadeTextProps> = ({ children, className, textKey }) => (
  <span className={twMerge('animate-reveal-fade', className)} key={textKey}>
    {children}
  </span>
);
